import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  closeOnOverlay(event) {
    if (event.target === this.element) {
      window.location.href = "/"
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      window.location.href = "/"
    }
  }
}
